document.addEventListener("DOMContentLoaded", function () {
    const getQuoteBtn = document.getElementById("getQuoteBtn");
    const modal = document.getElementById("quoteModal");
    const sendToWhatsApp = document.getElementById("sendToWhatsApp");
    const closeBtn = document.querySelector(".close");

    getQuoteBtn.addEventListener("click", function () {
        // Seçilen renk
        const selectedColorInput = document.querySelector(".swatch-input__input:checked");
        const selectedColor = selectedColorInput ? selectedColorInput.value : "Seçilmedi";

        // Seçilen adet ve fiyatı çek
        const selectedQuantity = document.getElementById("quantityField").value;
        const selectedTotalPrice = document.getElementById("totalPrice").innerText;

        // SKU Değerini Al
        const skuElement = document.querySelector(".product__sku");
        const selectedSku = skuElement ? skuElement.textContent.trim() : "Bilinmiyor";

        // Pop-up içindeki bilgileri güncelle
        document.getElementById("selectedColorText").innerText = selectedColor;
        document.getElementById("selectedQuantity").innerText = selectedQuantity;
        document.getElementById("selectedTotalPrice").innerText = selectedTotalPrice;
        document.getElementById("selectedSkuText").innerText = selectedSku;

        modal.style.display = "flex";
    });

    closeBtn.addEventListener("click", function () {
        modal.style.display = "none";
    });

    sendToWhatsApp.addEventListener("click", function () {
        const selectedColor = document.getElementById("selectedColorText").innerText;
        const selectedQuantity = document.getElementById("selectedQuantity").innerText;
        const selectedTotalPrice = document.getElementById("selectedTotalPrice").innerText;
        const selectedSku = document.getElementById("selectedSkuText").innerText;

        const phoneNumber = "905455726708"; // Firma WhatsApp numaranı yaz
        const message = `Merhaba, aşağıdaki teklif için iletişime geçmek istiyorum:%0A%0A🐀𐀀񞐠𘀤{selectedSku}%0A🔹 Seçilen Renk: ${selectedColor}%0A🔹 Adet: ${selectedQuantity}%0A🔹 Ara Toplam: ${selectedTotalPrice} `;

        window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
    });

    window.onclick = function(event) {
        if (event.target === modal) {
            modal.style.display = "none";
        }
    };
});

document.addEventListener("DOMContentLoaded", function () {
    const modalContent = document.querySelector(".modal-content");
    
    document.getElementById("getQuoteBtn").addEventListener("click", function () {
        modalContent.style.transform = "translateY(-1300px)"; // 300px yukarı taşı
    });
});
